import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './lib/leaflet-patch';
import './styles.css';
import { registerServiceWorker } from './lib/register-sw';
import { applyStandaloneViewport } from './lib/standalone-viewport';
import { enableViewportDebug } from './lib/viewport-debug';

applyStandaloneViewport();
enableViewportDebug();
registerServiceWorker();

// Lyt på Vite preload fejl ved nye releases/deploys (hvor chunks ændres),
// så brugeren transparent genindlæser uden at se en fejlskærm.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary fallbackTitle="Der opstod en fejl i arbejdspladsen">
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
